import { gql } from '@apollo/client'

export type Squad =
  | 'a'
  | 'b'
  | 'c'
  | 'd'
  | 'e'
  | 'f'
  | 'g'
  | 'h'
  | 'i'
  | 'j'
  | 'k'
  | 'l'
  | 'm'
  | 'n'

export type MutationVars = {
  userId: string
  skillLevel: number
  squads: Squad[]
}

export type Response = {
  updateExecutive: string
}

const mutation = gql`
  mutation updateExecutive($userId: ID!, $skillLevel: Int!, $squads: [Squad!]!) {
    updateExecutive(userId: $userId, skillLevel: $skillLevel, squads: $squads)
  }
`

export default mutation
